import { Component } from "react";
import { Input } from "reactstrap";
import { BankUserContext } from "../bankUserContext";
import "./dashboard.scss";
import Service from "../services";
import { AxiosError } from "axios";
import { catchError } from "../utils/Utils";
import { WithRouterProps, withRouter } from "../components/shared/WithRouter";
import { TrackersEnum } from "../models/TrackerModel";
import { RoutesEnum } from "../utils/RoutesUtil";


interface MangementReviewDashboardProps {
  match: { params: { clientProductId: any } };
  location: { pathname: string; search: any };
  submitFeedback: any;
  
}
class MangementReviewDashboard extends Component<
WithRouterProps<unknown>,
  any
> {
  static contextType = BankUserContext;
  constructor(props: any) {
    super(props);
    this.state = {
      isApprove: true,
      loader: true,
      status: "",
      comments: "",
      recomnd: "",
      initialStatus: "", 
         
    };
  }
  componentDidMount() {
   

  const clientProductId= (this.props?.params?.clientProductId);
    const service = new Service();
    clientProductId &&  service
      .getRecommendationStatus(clientProductId)
      .then((resp) => {
        
        this.setState({
          initialStatus: resp.data,
          status: resp.data,
        });
      });
  }
  

  componentDidUpdate() {
    console.log("vvv",this.props?.params)
    // const { updateClientId } = this.context;    
  // const clientProductsId= (this.props?.match?.params?.id)
  }
  checkApprovalStatus(e: any) {
    const val = e.target.value;  
    let status = "";
    let recomnd = "";
    if (val === "Accept") {
      status = this.state.initialStatus;
      recomnd = "Accept";
    } else if (val === "Change") {
      status = this.state.status === "Approve" ? "Decline" : "Approve";
      recomnd = "Change";
    } else {
      status = "Decline";
      recomnd = "Return";
    }
    this.setState({ status, recomnd });
  }
  
   backtoUnderwriting() {  
    
    let url = `/${RoutesEnum.TRACKER}/${(TrackersEnum.UNDERWRITING)}`;  
    
      const selectedProductRaw = sessionStorage.getItem("selectedProduct");
      if (selectedProductRaw) {
        const selectedProduct = JSON.parse(selectedProductRaw);
        if (selectedProduct) {
          url = `${url}/${selectedProduct?.orgLevelProductId}`;
        
      }
    }
  
    this.props.navigate(url);
  };
  
  submitAction(e: any) {   
    e.preventDefault();
    const service = new Service();
    service
      .changeRecommendation({
        clientProductId:this.props?.params?.clientProductId,      
        notes: this.state.comments,
        recomnd: this.state.recomnd || (this.state.initialStatus === "Approve"?'Accept':
        (this.state.initialStatus === 'Decline'?'Change':this.state.initialStatus)),

        status: this.state.status,
        
      })
      .then(() => {
        this.backtoUnderwriting()
      
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  }
 
  render() {
    return (
      <form onSubmit={this.submitAction.bind(this)}>
        <div className="review-container">
          <div className="reviewapprove">
            <span className="header">Summary Findings Report </span>
            <div className="recomendation">
              Recommendation
              {this.state.initialStatus === "Approve" ? (
                <div className="approve">{this.state?.initialStatus}</div>
              ) : (
                <div className="decline">{this.state?.initialStatus}</div>
              )}
            </div>
          </div>
          <div className="re">
          <div className="reviewcheck">
           
            <Input
              type="radio"
              name="reviewcheck"
              value="Accept"              
              defaultChecked
              onChange={this.checkApprovalStatus.bind(this)}             
            />
            <span className="checkvalue">Accept Recommendation</span>
          </div>
          <div className="reviewcheck MDBRadio">
            <Input
              type="radio"
              name="reviewcheck"
              value="Change"              
              onChange={this.checkApprovalStatus.bind(this)}             
            />
            <span className="checkvalue">
              Change Recommendation to  {this.state.initialStatus === "Approve" ? (
                <span className="decline">Decline</span>
              ) : (
                <span className="approve">Approve</span>
              )}
            </span>
          </div>
          <div className="reviewcheck">
            <Input
              type="radio"
              name="reviewcheck"
              value="Return"
              onChange={this.checkApprovalStatus.bind(this)}        
              
            />{" "}
            <span className="checkvalue">
              Return to Reviewer for further action{" "}
            </span>
          </div>
          </div>
         
          <div className="reviewcomments">
            
            <Input
              className="text-area-custom comm"              
              type="textarea"
              placeholder ={"Comments"}
              defaultValue="comments"
              value={this.state.comments}
              required={!(this.state.recomnd == "Accept")}
              onChange={(e: any) => this.setState({ comments: e.target.value })}
            />
          </div>         
          <Input
            className="reviewsubmit"
            type="submit"
            value="Submit"
            // disabled={
            //   //(!this.state.comments &&
            //     (this.state.recomnd == "")
            //     //|| !this.state.recomnd

            // }          
          />
        </div>
      </form>
    );
  }
}
export default withRouter<WithRouterProps<unknown>> (MangementReviewDashboard);
